

import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Button from "../../shared/button/Btn";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { showModal } from "../../../features/modal/modalSlice";
import { useScrollLock } from "../../../hooks/useScrollLock";
import PageTopTitle from "../../shared/PageTopTitle";
import { useState } from "react";
import InputText from "../../shared/input/new/InputText";
import InputNewAracTypeSelect from "../../shared/input/new/InputNewAracTypeSelect";
import InputPhoneNew from "../../shared/input/new/InputPhoneNew";
import { handleActiveSelect } from "../../../features/layout/layoutSlice";
import { addAdminTruckSingle } from "../../../features/admin2/admin2Slice";
import InputSelect from "../../shared/input/new/InputSelect";
import MarkaOptions from "../../../utils/trAracMarkaOptions";
import InputDate from "../../shared/input/new/InputDate";
import { AdminAracEkleOptions } from "../../../utils/adminAracEkleOptions";
import InputCaseTypeSelect from "../../shared/input/new/InputCaseTypeSelect";
import moment from "moment";
import ImageUploader from "../../docs/ImageUploader";
import { validateFile } from "../../../helper/docs/validateFile";
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat";
import plakaData from "../../../utils/jobListPlakaData";
import { addNewDevamliArac } from "../../../features/joblist/jobListSlice";
import { createRegularVehicle } from "../../../features/driversVehicles/driversVehiclesSlice";

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 900px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
          overflow: hidden;

        .content{
            padding: 40px 0 20px;
            width: 900px;
            display: flex;
            flex-direction: column;
            align-items: center;
            height: auto;
            max-height: 600px;
            overflow: auto !important;


            .input-list{

              display: flex;
              flex-direction: column;
              gap: 20px;
              
              .phone-border{
                border: 1px solid ${({theme}) => theme.mainBorderColor};
                padding: 10px 15px;
                border-radius: 10px;
              }


                h2{
                  font-size: 18px;
                  font-weight: 600;
                  text-align: center;
                  width: 440px;
                }


            }


    .doc-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 440px;
        margin-top: 45px;

        h2{
          font-size: 18px;
          font-weight: 600;
          text-align: center;
          padding-bottom: 20px;
          width: 440px;
        }

        .doc-list{
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          gap: 30px;
        }

        
        .doc-item{
            width: 100%;
            height: 400px;
            border: 1px solid ${({theme}) => theme.mainTextColor};
            border-radius: 10px;
            overflow: hidden;
            
            .doc-item-top{
                width: 100%;
                height: 50px;
                border: 1px solid ${({theme}) => theme.mainBorderColor};
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);

                .action{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;

                        span{

                            &:first-child{
                                width: 60px;
                            }
                        }


                        .delete-btn{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                            /* background-color: var(--color-main); */
                            color: #fff;
                            color: var(--color-main);
                            border: 1px solid var(--color-main);
                            padding: 5px 7px;
                            border-radius: 5px;
                            cursor: pointer;
                            margin-right: 10px;
                            transition: .2s;

                            &:hover{
                                background-color: var(--color-main);
                                color: #fff;
                            }
                        }
                    }
            }
        }

        .new-select-item{
            border-color: red;
            border-width: 2px;

            .new-select-item-top{
                background-color: #ff000040;
            }
        }
    }
        }

        .btn-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: auto;
            height: 70px;
            gap: 40px;
            border-top: 1px solid ${({theme}) => theme.mainBorderColor};
        }
    }
`
const AddRegularDriversVehicleModal = () => {
 
    const {isNewDriverData} = useSelector(state => state.jobList)

    const {queriedPhoneNumberForRegularDriver} = useSelector(state => state.driversVehicles)

     const [fileList, setFileList] = useState([
          {
              selectedFile: null,
              loadedBefore: null,
              fileTypeName: "Ruhsat",
              staticValue: "ruhsat"
          },
          {
              selectedFile: null,
              loadedBefore:  null,
              fileTypeName: "Taşıt Kartı",
              staticValue: "TasitKartiPhoto"
          },
          {
              selectedFile: null,
              loadedBefore:  null,
              fileTypeName: "Şase",
              staticValue: "SasePhoto"
          },
          {
              selectedFile: null,
              loadedBefore:  null,
              fileTypeName: "Trafik Sigorta Poliçesi",
              staticValue: "TrafikSigortaPolicePohoto"
          },
          {
              selectedFile: null,
              loadedBefore:  null,
              fileTypeName: "Yük Sigorta Poliçesi",
              staticValue: "YukSigortaPolicePhoto"
          },
          {
              selectedFile: null,
              loadedBefore: null,
              fileTypeName: "Araç Foto Önden Sürücülü",
              staticValue: "AracFotoOndenSuruculu"
          },
          {
              selectedFile: null,
              loadedBefore:  null,
              fileTypeName: "Araç Foto Önden",
              staticValue: "Photo1"
          },
          {
              selectedFile: null,
              loadedBefore: null,
              fileTypeName: "Araç Foto Yandan",
              staticValue: "Photo2"
          },
          {
              selectedFile: null,
              loadedBefore: null,
              fileTypeName: "Araç Foto Arkadan",
              staticValue: "Photo3"
          },
      ])

  const { modalLocation } = useSelector((state) => state.modal);
  const dispatch = useDispatch();
  const location = useLocation();
  const { lockScroll, unlockScroll } = useScrollLock();

  const [initialCaseType, setInitialCaseType] = useState(null)

  const [truckPlateNumber, setTruckPlateNumber] = useState("")
  const [truckType, setTruckType] = useState("")
  const [truckBrand, setTruckBrand] = useState("")
  const [truckModel, setTruckModel] = useState("")
  const [truckModelYear, setTruckModelYear] = useState("")
  const [trafikSigortasıGecerlilikTarihi, setTrafikSigortasıGecerlilikTarihi] = useState("")
  const [muayeneGecerlilikTarihi, setMuayeneGecerlilikTarihi] = useState("")
  const [kaskoGecerlilikTarihi, setKaskoGecerlilikTarihi] = useState("")
  const [trailerTypeId, setTrailerTypeId] = useState("")
  const [trailerType, setTrailerType] = useState("")

  // //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);



  // //! araç türü çekici ise kasa tipini sıfırla
  useEffect(() => {
    if(truckType?.name === "Çekici"){
      setTrailerType(null)
    }
  },[truckType])


      const handleFileSelect = async(index, files) => {
  
          const file = await validateFile({file: files[0], maxSize: 5 * 1024 * 1024, allowedTypes:['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']})
          
          if(file){
              const newUploads = [...fileList];
              newUploads[index].selectedFile = files[0];
              setFileList(newUploads);
          }
        };



  const handleSubmit = () => {

    
    
    if(truckPlateNumber && truckType.name){
  // if(phoneNumber.slice(2).length === 10 && truckPlateNumber && truckType && truckBrand && (truckType?.name !== "Çekici" ? trailerType?.name : true) && (truckType?.name !== "Çekici" ? trailerType?.id : true)){

    
    const formData = new FormData()
    formData.append("phoneNumber", queriedPhoneNumberForRegularDriver)
    formData.append("truckPlateNumber", truckPlateNumber)
    formData.append("truckType", truckType.name)
    formData.append("truckBrand", truckBrand.text)
    formData.append("truckModel", truckModel)
    formData.append("truckModelYear", truckModelYear)
    formData.append("trafikSigortasıGecerlilikTarihi", trafikSigortasıGecerlilikTarihi)
    formData.append("muayeneGecerlilikTarihi", muayeneGecerlilikTarihi)
    formData.append("kaskoGecerlilikTarihi", kaskoGecerlilikTarihi)
    formData.append("trailerTypeId", truckType?.name === "Çekici" ? "" : trailerType?.id)
    formData.append("trailerType", truckType?.name === "Çekici" ? "" : trailerType?.name)


    formData.append("Ruhsat", fileList[0].selectedFile)
    formData.append("TasitKartiPhoto", fileList[1].selectedFile)
    formData.append("SasePhoto", fileList[2].selectedFile)
    formData.append("TrafikSigortaPolicePohoto", fileList[3].selectedFile)
    formData.append("YukSigortaPolicePhoto", fileList[4].selectedFile)
    formData.append("AracFotoOndenSuruculu", fileList[5].selectedFile)
    formData.append("Photo1", fileList[6].selectedFile)
    formData.append("Photo2", fileList[7].selectedFile)
    formData.append("Photo3", fileList[8].selectedFile)
    

    dispatch(createRegularVehicle(formData))
    }
  // }
  };

  return (
    <Container onClick={() => {; dispatch(showModal(null))}}>
      <div onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}  className="modal">
        <PageTopTitle title={"Araç Ekle"} />
        <div className="content">

        <div className="input-list">

          <h2>Araç Bilgileri</h2>

          <div className="input-grp">
              <div className="phone-border">
                  <div style={{fontSize: "14px", fontWeight: 600}}>Telefon Numarası: {queriedPhoneNumberForRegularDriver}</div>
              </div>
          </div>

          <div className="input-grp">
            <InputText
              data={truckPlateNumber}
              setData={(e) => setTruckPlateNumber(e.target.value)}
              inputWidth={"100%"}
              labelText="Plaka*"
              name={"truckPlateNumber"}
            />
          </div>

          <div className="input-grp">
            <InputNewAracTypeSelect
              initialOptions={AdminAracEkleOptions}
              setInitialCaseType={setInitialCaseType}
              data={truckType?.name || ""}
              setData={setTruckType}
              inputWidth={"100%"}
              labelText="Araç Türü*"
              name={"truckType"}
            />
          </div>

            {
              truckType?.name !== "Çekici" &&
              <div className="input-grp">
                <InputCaseTypeSelect 
                  initialOptions={initialCaseType}
                  data={trailerType}
                  setData={setTrailerType}
                  inputWidth={"100%"}
                  labelText="Kasa Tipi (Opsiyonel)"
                  name={"selectCaseType"}
                />
              </div>
            }

            <div className="input-grp">
                <InputSelect
                  initialOptions={MarkaOptions}
                  data={truckBrand.text || ""}
                  setData={setTruckBrand}
                  inputWidth={"100%"}
                  labelText="Araç Markası (Opsiyonel)"
                  name={"truckBrand"}
                />
            </div>

            <div className="input-grp">
                <InputText
                  data={truckModel}
                  setData={(e) => setTruckModel(e.target.value)}
                  inputWidth={"100%"}
                  labelText="Araç Modeli (Opsiyonel)"
                  name={"truckModel"}
                />
            </div>

            <div className="input-grp">
                <InputText
                  data={truckModelYear}
                  setData={(e) => setTruckModelYear(e.target.value)}
                  inputWidth={"100%"}
                  labelText="Araç Model Yılı (Opsiyonel)"
                  name={"truckModelYear"}
                />
            </div>

              {
                (truckType?.name !== "Y.Römork" && truckType?.name !== "Römork") &&
                <div className="input-grp">
                  <InputDate
                    data={trafikSigortasıGecerlilikTarihi}
                    setData={(e) => setTrafikSigortasıGecerlilikTarihi(e.target.value)}
                    inputWidth={"100%"}
                    labelText="Trafik Sigortası Geçerlilik Tarihi (Opsiyonel)"
                    name={"trafikSigortasıGecerlilikTarihi"}
                  />
                </div>
              }

              <div className="input-grp">
                 <InputDate
                  data={muayeneGecerlilikTarihi}
                  setData={(e) => setMuayeneGecerlilikTarihi(e.target.value)}
                  inputWidth={"100%"}
                  labelText="Muayene Geçerlilik Tarihi (Opsiyonel)"
                  name={"muayeneGecerlilikTarihi"}
                />
              </div>

              <div className="input-grp">
                <InputDate
                  data={kaskoGecerlilikTarihi}
                  setData={(e) => setKaskoGecerlilikTarihi(e.target.value)}
                  inputWidth={"100%"}
                  labelText="Kasko Geçerlilik Tarihi (Opsiyonel)"
                  name={"kaskoGecerlilikTarihi"}
                />
              </div>


        </div>

              <div className="doc-container">
              <h2>Araç Belgeleri</h2>
              <div className="doc-list">
                              {
                                  fileList.map((fileItem, index) => {
                                      let previewSrc;
                                      let isPdf;
                                      if (fileItem.selectedFile) {
                                          isPdf = fileItem.selectedFile.type === "application/pdf"
                                        previewSrc = URL.createObjectURL(fileItem.selectedFile);
              
                                      } else if (fileItem.loadedBefore) {
                                        previewSrc = `${process.env.REACT_APP_API_IMG_URI}${fileItem.loadedBefore}`;
                                      } else {
                                        previewSrc = "question";
                                      }
              
                                      return (
                                          <div className={fileItem.selectedFile ? "new-select-item doc-item" : "doc-item"}>
                                               <div className={fileItem.selectedFile ? "new-select-item-top doc-item-top" : "doc-item-top"}>
                                                  {fileItem.selectedFile ? (
                                                      <p>Yeni Seçilen Belge: {fileItem.selectedFile.name} - ({fileItem.fileTypeName})</p>
                                                  ) : fileItem.loadedBefore ? (
                                                      <p className="action">
                                                          <span></span>
                                                          <span>Önceden Yüklenmiş Belge - ({fileItem.fileTypeName})</span>
                                                          <button className="delete-btn" onClick={() => {}}>---</button>
                                                      </p>
                                                  ) : (
                                                      <p>Belge Seçilmedi - ({fileItem.fileTypeName})</p>
                                                  )}
                                              </div>
                                              <ImageUploader
                                                  previewSrc={previewSrc}
                                                  isPdf={isPdf} 
                                                  onFileSelect={(files) => handleFileSelect(index, files)} 
                                              />
                                              
                                          </div>
                                      )
                                  }) 
                              }
                          </div>
</div>
        </div>
        <div className="btn-grp">
          <Button
            width="150px"
            handleClick={handleSubmit}
            padding="10px"
            bgColor="#E85446"
            color={"#fff"}
          >
            Ekle
          </Button>
          <Button
            width="150px"
            handleClick={() => dispatch(showModal(null))}
            padding="10px"
            bgColor="#fff"
            color={"#E85446"}
          >
            Vazgeç
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default AddRegularDriversVehicleModal